import { humanizeFieldName } from './helpers'

export default {
  getMessage: field => `The ${humanizeFieldName(field)} cannot contain spaces.`,
  validate (value) {
    return /^([\S]+)$/u.test(value)
  }
}
